window.Vue = require('vue');
_ = require('lodash');

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

// VueRouter gets imported once in frontend.js to prevent errors
Vue.use(window.VueRouter);

import VueMobileDetection from "vue-mobile-detection";
Vue.use(VueMobileDetection);

import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

/* FLARE */
import { flare } from "@flareapp/flare-client";
import { flareVue } from "@flareapp/flare-vue";

if (process.env.NODE_ENV === 'production') {
    if(window.sharedData !== undefined && window.sharedData.flare_js_key !== undefined) {
        if(window.sharedData.flare_js_key !== null && window.sharedData.flare_js_key.length !== 0) {
            flare.light(window.sharedData.flare_js_key);
        }
    }
}

Vue.use(flareVue);


function _get(target, key, force) {

    target = target || null;
    key = key || null;
    force = force || false;

    if(key === null) {
        if(!target) {
            return (force) ? '--' : '';
        } else {
            return target;
        }
    }

    if( typeof target === 'undefined' || typeof key === 'undefined' || !(key in target) || typeof target[key] === 'undefined' || target[key] === '' ) {
        return (force) ? '--' : '';
    } else {
        return target[key];
    }
}

function _num(num, dec, suf, pre) {

    num = parseFloat(num) || 0;
    dec = dec || 0;
    suf = suf || '';
    pre = pre || '';

    num = num.format(dec, null, '.', ',');

    return pre + num + suf;
}


if(typeof window.sharedData !== 'undefined' && typeof window.sharedData.vehicles !== 'undefined') {

    // create url object to track filter url
    // we don't do that here, just a spacer

    const router = new VueRouter({
        mode: 'history',
        base: __dirname,
        routes: []
    });

    var filter = window.sharedData.filter;
    var marken_modelle = window.sharedData.marken_modelle;
    var vueResizeTimer;

    const app = new Vue({
        router,
        el: '#componentVehicleSearchVueApp',
        data() {
            return {
                devmode: window.sharedData.devmode,
                dealerPrices: window.sharedData.dealer_prices,
                infiniteLoading: false,
                mobile: true,
                outerWidth: $(window).outerWidth(),
                url: window.sharedData.url,
                preserve_count: null,
                counterData: [],
                countLoading: false,
                ajaxCounterUrl: window.sharedData.ajaxCounterUrl,
                isLoading: true,
                fullPage: false,
                filtered: false,
                sortBy: window.sharedData.sortBy,
                perPage: window.sharedData.perPage,
                page: window.sharedData.currentPage,
                active_filters: window.sharedData.activeFilters,
                marken: window.sharedData.marken,
                types: window.sharedData.types,
                extras: window.sharedData.extras,
                filter_names: window.sharedData.filter_names,
                vehicles: window.sharedData.vehicles,
                vehicle_count: window.sharedData.vehicle_count,
                clone_count: window.sharedData.clone_count,
                vehicle_filter_count: window.sharedData.vehicle_count,
                lp_count: window.sharedData.lp_count,
                lp_filter_count: window.sharedData.lp_count,
                vehicles_parked: [],
                page_count: window.sharedData.page_count,
                max_pages: window.sharedData.max_pages,
                vehicles_displayed_from: 1,
                vehicles_displayed_to: window.sharedData.perPage,
                disturbers: window.sharedData.disturbers,
                lps: window.sharedData.lps,
                special_offers: window.sharedData.special_offers,
                special_offer_count: window.sharedData.special_offer_count,
                special_offer_filter_count: window.sharedData.special_offer_count,

                /*
                no tracking
                in component search
                only in main search
                see vehicle-search.js
                this is just a spacer so I can
                keep up with both search versions */

                filter_type: filter.type.preset,
                filter_leasing: filter.leasing.preset,
                filter_payment: filter.payment.preset,
                filter_marke: filter.marke.preset,
                filter_modell: filter.modell.preset,
                filter_motorisierung: filter.motorisierung.preset,
                filter_extras: filter.extras.preset,
                filter_karosserie: filter.karosserie.preset,
                filter_standort: filter.standort.preset,
                filter_erstzulassung: [
                    filter.erstzulassung.preset[0],
                    filter.erstzulassung.preset[1]
                ],
                filter_km: [
                    filter.km.preset[0],
                    filter.km.preset[1]
                ],
                filter_preis: [
                    filter.preis.preset[0],
                    filter.preis.preset[1]
                ],
            }
        },

        watch: {
            filter_type() {

                if (this.filter_type.length > 0) {
                    this.filter_leasing = false;
                }

                this.refreshCounters();
            },
            filter_leasing() {

                if (this.filter_leasing) {
                    this.filter_type = [];
                }

                this.refreshCounters();
            },
            filter_marke() {
                this.refreshCounters();
            },
            filter_modell() {
                this.refreshCounters();
            },
            filter_karosserie() {
                this.refreshCounters();
            },
            filter_motorisierung() {
                this.refreshCounters();
            },
            filter_standort() {
                this.refreshCounters();
            },
            filter_extras() {
                this.refreshCounters();
            },
            filter_erstzulassung() {
                this.refreshCounters();
            },
            filter_km() {
                this.refreshCounters();
            },
            filter_preis() {
                this.refreshCounters();
            },
            vehicles_parked() {
                // console.log(this.vehicles_parked);
            },
        },

        mounted () {
            window.addEventListener('resize', this.handleResize);
            document.addEventListener('scroll', this.handleLastResult)
            // window.dispatchEvent(new Event('resize'));
            this.setIsMobile();
            this.refreshCounters();

            // if vehicle brand is preset, but no related models, check all models of that brand
            if(this.filter_marke.length > 0 && this.filter_modell.length < 1) {

                var temp = [];
                $.each(this.filter_marke, function(index, marke) {
                    temp.push( Object.values(marken_modelle[marke]) );
                });

                temp = _.flatten(temp);

                if(temp.length > 0) {
                    this.filter_modell = temp[0];
                }
            }

            Vue.$cookies.config('90d');
            let cookie = Vue.$cookies.get('vehicles_parked');

            if(cookie !== null) {
                let vehiclesParkedJson = JSON.parse(decodeURIComponent(cookie));
                window.vehiclesParked = _.uniq(vehiclesParkedJson);
            }

            this.vehicles_parked = window.vehiclesParked;

            // make app accessible in other scopes
            let that = this;

            // watch parked vehicles
            setInterval(function () {
                that.vehicles_parked = window.vehiclesParked;
            }, 1000);

            /*
            ---
            ---
            ---
            ---
            ---
            ---
            ---
            ---
            ---
            ---
            ---
            no tracking in component search, this is just a spacer
            ---
            ---
            ---
            ---
            ---
            ---
            ---
            ---
            ---
            ---
            ---
            */
        },

        methods : {

            handleResize: function() {
                clearTimeout(vueResizeTimer);

                vueResizeTimer = setTimeout(function() {
                    // console.log('handleResize');
                    this.outerWidth = $(window).outerWidth();
                    this.setIsMobile();
                    // this.mobile = this.getIsMobile;
                }.bind(this), 500);
            },

            handleLastResult: function() {
                if(!this.infiniteLoading) {
                    if( $('#infiniteScrollTrigger').isOnScreen() === true ) {
                        this.infiniteLoading = true;
                        setTimeout(function () {
                            this.nextPage();
                        }.bind(this), 500)
                    }
                }
            },

            refreshCounters: function(emptyField) {

                this.isLoading = true;
                emptyField = emptyField || null;

                if(this.countLoading === false) {

                    this.countLoading = true;
                    axios.post(this.ajaxCounterUrl, {
                        emptyField: emptyField,
                        dealerPrices: this.dealerPrices,
                        lp_count: this.lp_filter_count,
                        isFiltered: this.filtered,
                        activeFilters: this.active_filters,
                        filters: {
                            counter_data: this.counterData,
                            preserve_count: this.preserve_count,
                            type: this.filter_type,
                            leasing: this.filter_leasing,
                            marke: this.filter_marke,
                            modell: this.filter_modell,
                            motorisierung: this.filter_motorisierung,
                            extras: this.filter_extras,
                            karosserie: this.filter_karosserie,
                            standort: this.filter_standort,
                            erstzulassung: this.filter_erstzulassung,
                            km: this.filter_km,
                            preis: this.filter_preis,
                        }
                    })
                    .then(response => {
                        if(response.data !== null) {
                            this.counterData = response.data.counter;
                        } else {
                            this.counterData = [];
                        }
                        this.countLoading = false;
                        this.isLoading = false;
                    });
                }
            },

            sendForm: function() {

                var url = this.url;
                var query = '';

                if(this.filtered) {
                    query = '?q=1';

                    if(this.filter_type.length) {
                        query = query + '&type=' + this.filter_type.join('|');
                    }
                    if(this.filter_leasing) {
                        query = query + '&leasing=' + this.filter_leasing;
                    }
                    if(this.filter_marke.length) {
                        query = query + '&marke=' + this.filter_marke.join('|');
                    }
                    if(this.filter_modell.length) {
                        query = query + '&modell=' + this.filter_modell.join('|');
                    }
                    if(this.filter_karosserie.length) {
                        query = query + '&karosserie=' + this.filter_karosserie.join('|');
                    }
                    if(this.filter_motorisierung.length) {
                        query = query + '&motorisierung=' + this.filter_motorisierung.join('|');
                    }
                    if(this.filter_standort.length) {
                        query = query + '&standort=' + this.filter_standort.join('|');
                    }
                    if(this.filter_extras.length) {
                        query = query + '&extras=' + this.filter_extras.join('|');
                    }
                    if(this.filter_erstzulassung.length) {
                        query = query + '&erstzulassung=' + this.filter_erstzulassung.join('|');
                    }
                    if(this.filter_km.length) {
                        query = query + '&km=' + this.filter_km.join('|');
                    }
                    if(this.filter_preis.length) {
                        query = query + '&preis=' + this.filter_preis.join('|');
                    }
                }

                location.href = url + query;
            },

            someOtherFunction: function(marke) {

                var modelle;
                var hauptMarken = ['Ford', 'Volvo', 'Land Rover', 'Jaguar', 'Weitere Marken'];
                var andereMarken = Object.keys(marken_modelle);
                var currentMarken = this.filter_marke;
                andereMarken = _.difference(andereMarken, hauptMarken);

                if(marke === 'other') {

                    // activate all models
                    if( !_.includes(this.filter_marke, 'Weitere Marken') ) {
                        this.filter_marke = _.union(currentMarken, andereMarken);
                    } else {
                        this.filter_marke = _.difference(currentMarken, andereMarken);
                        this.refreshCounters('marke');
                    }

                } else {

                    var temp = Object.values(marken_modelle[marke]);

                    // activate all models
                    if( !_.includes(this.filter_marke, marke) ) {
                        modelle = _.union(this.filter_modell, temp);
                        modelle = _.compact(modelle);
                        this.filter_modell = modelle;
                    } else {
                        modelle = _.difference(this.filter_modell, temp);
                        this.filter_modell = Object.values(modelle);
                        this.refreshCounters('marke');
                    }
                }
            },

            setPreserveCount: function(preserve_count) {
                this.preserve_count = preserve_count;
            },

            _val: function(key, source) {
                if( typeof source === 'undefined' || typeof key === 'undefined' || !(key in source) || typeof source[key] === 'undefined' || source[key] === '' ) {
                    return null;
                } else {
                    return source[key];
                }
            },

            _length: function(val) {

                if( Array.isArray(val) ) {
                    return val.length;
                }

                if( typeof val === 'object' ) {
                    return Object.keys(val).length;
                }

                return 0;
            },

            // formatting values
            formatKm: function(km) {
                return _num(km, 0, ' km');
            },

            formatPreis: function(preis) {
                return _num(preis, 0, ' €');
            },

            _get: function(target, key, force) {
                return _get(target, key, force);
            },

            _num: function(num, dec, suf, pre) {
                return _num(num, dec, suf, pre);
            },

            resetFilters: function() {
                //
                this.filtered = false;
                this.active_filters = [];

                this.filter_type = [];
                this.filter_leasing = 0;
                this.filter_marke = [];
                this.filter_modell = [];
                this.filter_karosserie = [];
                this.filter_motorisierung = [];
                this.filter_standort = [];
                this.filter_extras = [];

                this.filter_erstzulassung = [filter.erstzulassung.min, filter.erstzulassung.max];
                this.filter_km = [filter.km.min, filter.km.max];
                this.filter_preis = [filter.preis.min, filter.preis.max];

                this.preserve_count = null;
                this.vehicle_filter_count = this.vehicle_count;
                this.lp_filter_count = this.lp_count;
                this.page = 0;
                this.max_pages = Math.ceil(this.vehicle_filter_count / this.perPage);
            },

            removeFilter: function(filter_name) {

                // no changing of url
                // in component search

                // sliders or inputs
                if(filter_name === 'erstzulassung' || filter_name === 'km' || filter_name === 'preis') {
                    this['filter_' + filter_name] = [ filter[filter_name].min, filter[filter_name].max ];
                } else if (filter_name === 'leasing') {
                    this['filter_' + filter_name] = 0;
                } else {
                    this['filter_' + filter_name] = [];
                }

                this.preserve_count = null;
                this.max_pages = Math.ceil(this.vehicle_filter_count / this.perPage);
                this.active_filters = _.filter(this.active_filters, filter_name);
            },

            filterName: function(filter_name) {
                return this.filter_names[filter_name];
            },

            typeName: function(type) {
                return this.types[type];
            },

            prevPage: function() {
                if(this.page > 0) {
                    this.page = this.page - 1;
                }

                //
            },

            nextPage: function() {
                if(this.page < this.max_pages - 1) {
                    this.page = this.page + 1;
                }

                // used for infinite scroll
                if(this.mobile) {
                    this.infiniteLoading = false;
                }

                //
            },

            setPage: function(page) {
                this.page = page - 1;
                //
            },

            setPerPage: function(perPage) {
                this.showLoader();
                this.page = 0;
                this.perPage = perPage;
                this.max_pages = Math.ceil(this.vehicle_filter_count / this.perPage);
                //
            },

            setPerPageAll: function() {
                this.showLoader();
                setTimeout(() => {
                    this.setPerPage(this.vehicle_filter_count);
                },1000);
            },

            parkVehicle: function(id, name, price, url) {

                let vehiclesParked = window.vehiclesParked;
                let car = new Object({
                    id: id,
                    name: name,
                    price: price,
                    url: url,
                });

                let isParked = _.find(vehiclesParked, function(v) { return v.id === id; });

                if(typeof isParked !== 'undefined') {
                    vehiclesParked = _.remove(vehiclesParked, function(v) {
                        return v.id !== id;
                    });
                } else {
                    if(vehiclesParked.length < 9) {
                        vehiclesParked.push(car);
                    }
                }

                vehiclesParked = _.uniq(vehiclesParked);
                let vehiclesParkedJson = JSON.stringify(vehiclesParked);

                Vue.$cookies.set('vehicles_parked', vehiclesParkedJson);
                this.vehicles_parked = vehiclesParked;
                window.vehiclesParked = vehiclesParked;
            },

            isParked: function(id) {
                let isParked = _.find(this.vehicles_parked, function(v) { return v.id === id; });
                return typeof isParked !== 'undefined';
            },

            showLoader: function() {
                this.isLoading = true;
                setTimeout(() => {
                    this.isLoading = false
                },1000);
            },

            /*resetUrlParams() { // we do none of that here
                const url = window.currentUrl;
                window.currentUrl = new URL(url.href.split('?')[0]);
            },

            addUrlParam(key, val) {
                const url = window.currentUrl;
                url.searchParams.delete(key);
                url.searchParams.set('q', 1);
                url.searchParams.set(key, val);
                window.currentUrl = url;
            },

            removeUrlParam(key) {
                const url = window.currentUrl;
                url.searchParams.delete(key);
                window.currentUrl = url;
            },


            saveSearch(searchParams) {

                // console.log('saveSearch');
                axios.post(this.ajaxSaveTrackedSearchUrl, {
                    searchParams: searchParams,
                })
                    .then(response => {
                        if(response.data !== null) {
                            // console.log(response.data);
                        }
                    });
            },


            trackSearch(searchParams) {

                let oldSearchParams = searchParams;
                let currentSearchParams = {
                    'leasing': this.filter_leasing,
                    'type': this.filter_type,
                    'marke': this.filter_marke,
                    'modell': this.filter_modell,
                    'karosserie': this.filter_karosserie,
                    'motorisierung': this.filter_motorisierung,
                    'standort': this.filter_standort,
                    'extras': this.filter_extras,
                    'erstzulassung': this.filter_erstzulassung,
                    'km': this.filter_km,
                    'preis': this.filter_preis
                };

                // just do on initial load
                if(this.first_load === true) {
                    // console.log('CREATE INITIAL SEARCH');

                    if(this.active_filters.length > 0) {
                        // console.log('GOLD USER');
                        currentSearchParams.prefiltered = true;
                    }

                } else {

                    if( _.isEqual(oldSearchParams, currentSearchParams) ) {

                        // only check this if both times haven't been achieved yet
                        if(this.trackSearchInactivityDuration10s !== true) {

                            // set record of seconds
                            if(this.trackSearchInactivityDuration5s === true) {
                                // console.log('search unchanged for 10s - UPDATE SEARCH');
                                currentSearchParams.inactivity_duration_10s = true;
                                this.trackSearchInactivityDuration10s = true;
                            } else {
                                // console.log('search unchanged for 5s - UPDATE SEARCH');
                                currentSearchParams.inactivity_duration_5s = true;
                                this.trackSearchInactivityDuration5s = true;
                            }

                        }

                    } else {
                        // restart loop, reset variables
                        // console.log('search changed - CREATE NEW SEARCH');

                        currentSearchParams.inactivity_duration_5s = false;
                        currentSearchParams.inactivity_duration_10s = false;
                        this.trackSearchInactivityDuration5s = false;
                        this.trackSearchInactivityDuration10s = false;

                        clearInterval(this.trackSearchInterval);
                        this.trackSearchInterval = null;
                    }

                }

                this.saveSearch(currentSearchParams);

            },
            */

            getVehicleDisturber: function(key) {
                if(this.disturbers[key] !== undefined) {
                    var disturber = this.disturbers[key];
                    return [disturber]
                }
            },

            getCount: function(key) {

                if(key === 'leasing') {
                    return _get(this.counterData, key);
                }

                let keys = key.split('.');
                let count;

                if(keys.length > 0) {
                    count = _get(this.counterData, keys[0]);
                }

                if(count && keys.length === 2) {
                    count = _get(count, keys[1]);
                }

                if(!count) {
                    count = 0;
                }

                return count;
            },

            filterErstzulassungMin: function() {
                return this.filter_erstzulassung[0];
            },

            filterErstzulassungMax: function() {
                return this.filter_erstzulassung[1];
            },

            filterKmMin: function() {
                return _num(this.filter_km[0], 0, ' km');
            },

            filterKmMax: function() {
                return _num(this.filter_km[1], 0, ' km');
            },

            filterPreisMin: function() {
                return _num(this.filter_preis[0], 0, ' €');
            },

            filterPreisMax: function() {
                return _num(this.filter_preis[1], 0, ' €');
            },

            setIsMobile: function() {
                if(this.$isMobile() || this.outerWidth < 768) {
                    this.mobile = true;
                    if(this.perPage !== 10) {
                        this.setPerPage(10);
                    }
                } else {
                    this.mobile = false;
                }
            },

        },

        computed: {

            getIsMobile: function() {
                return this.mobile;
            },

            getPreserveCount: function() {
                return this.preserve_count;
            },

            getCounterData: function() {
                return this.counterData;
            },

            loaderClass: function() {
                if(this.isLoading === true) {
                    return 'loading';
                }
                return 'loaded';
            },

            getIsLoading: function() {
                return this.isLoading;
            },

            isFiltered: function() {
                return this.filtered;
            },

            getActiveFilters: function() {
                return this.active_filters;
            },

            filterType: function() {
                if(this.filter_type.length > 0) {
                    this.filter_leasing = 0;
                }
                return this.filter_type;
            },

            filterLeasing: function() {
                if(this.filter_leasing) {
                    return 1;
                } else {
                    return 0;
                }
            },

            filterPayment: function() {
                if(this.filter_payment) {
                    return 1;
                } else {
                    return 0;
                }
            },

            filterMarke: function() {
                return this.filter_marke;
            },

            filterModell: function() {
                return this.filter_modell;
            },

            filterMarkeModellString: function() {
                let string = '';
                let markeModell = this.filter_marke.concat(this.filter_modell)

                if(markeModell.length > 0) {
                    string = markeModell.join(', ');
                }

                return string;
            },

            filterKarosserie: function() {
                return this.filter_karosserie;
            },

            filterKarosserieString: function() {
                let string = '';

                if(this.filter_karosserie.length > 0) {
                    string = string + this.filter_karosserie.join(', ');
                }

                return string;
            },

            filterMotorisierung: function() {
                return this.filter_motorisierung;
            },

            filterMotorisierungString: function() {
                let string = '';

                if(this.filter_motorisierung.length > 0) {
                    string = string + this.filter_motorisierung.join(', ');
                }

                return string;
            },

            filterStandort: function() {
                return this.filter_standort;
            },

            filterStandortString: function() {
                let string = '';

                if(this.filter_standort.length > 0) {
                    string = string + this.filter_standort.join(', ');
                }

                return string;
            },

            filterExtras: function() {
                return this.filter_extras;
            },

            filterExtrasString: function() {
                let string = '';
                let filterExtras = this.filter_extras;
                let extras = this.extras;

                $.each(this.filter_extras, function(index, value) {
                    value = parseInt(value);
                    string = string + extras[value];

                    if(filterExtras.length > 1) {
                        string = string + ', ';
                    }
                });

                return string;
            },

            filteredVehicles: function() {

                if (this.vehicles == null) {
                    return [];
                }

                /*




                 */

                var results = this.vehicles;
                this.active_filters = [];

                // Checkboxen
                if (this.filter_type.length > 0 && this.filter_leasing) {
                    results = _.filter(results, result => _.includes(this.filter_type, result.tp) && result.ls === 1);
                    this.active_filters.push('type');
                    this.active_filters.push('leasing');
                    //
                    //

                } else {
                    if (this.filter_type.length > 0) {
                        results = _.filter(results, result => _.includes(this.filter_type, result.tp));
                        this.active_filters.push('type');
                        //
                    }
                    //
                    //
                    if (this.filter_leasing) {
                        results = _.filter(results, result => result.cl === true); // clones
                        results = _.filter(results, result => result.ls === 1);
                        this.active_filters.push('leasing');
                        //
                    } else {
                        //
                        results = _.filter(results, result => result.cl === false); // clones
                    }
                }

                // Dropdowns
                if(this.filter_marke.length > 0 && this.filter_modell.length > 0) {

                    results = _.filter(results, result => _.includes(this.filter_marke, result.fr_mk) || _.includes(this.filter_marke, result.mk) || _.includes(this.filter_modell, result.mlt));
                    this.active_filters.push('marke');
                    this.active_filters.push('modell');

                    //
                    //

                } else {

                    if (this.filter_marke.length > 0) {
                        results = _.filter(results, result => _.includes(this.filter_marke, result.fr_mk) || _.includes(this.filter_marke, result.mk));
                        this.active_filters.push('marke');

                        //
                    }
                    //
                    //

                    if (this.filter_modell.length > 0) {
                        results = _.filter(results, result => _.includes(this.filter_modell, result.mlt));
                        this.active_filters.push('modell');

                        //
                    }
                    //
                    //
                }

                if (this.filter_karosserie.length > 0) {
                    results = _.filter(results, result => _.includes(this.filter_karosserie, result.ke));
                    this.active_filters.push('karosserie');

                    //
                }
                //
                //

                if (this.filter_motorisierung.length > 0) {
                    results = _.filter(results, result => _.includes(this.filter_motorisierung, result.mg));
                    this.active_filters.push('motorisierung');

                    //
                }
                //
                //

                if (this.filter_standort.length > 0) {
                    results = _.filter(results, result => _.includes(this.filter_standort, result.so));
                    this.active_filters.push('standort');

                    //
                }
                //
                //

                if (this.filter_extras.length > 0) {
                    results = _.filter(results, result => _.difference(this.filter_extras, result.ex).length === 0);
                    this.active_filters.push('extras');

                    //
                }
                //
                //


                // Slider
                if (this.filter_erstzulassung[0] > filter.erstzulassung.min || this.filter_erstzulassung[1] < filter.erstzulassung.max) {
                    results = _.filter(results, result => result.ez >= this.filter_erstzulassung[0]);
                    results = _.filter(results, result => result.ez <= this.filter_erstzulassung[1]);
                    this.active_filters.push('erstzulassung');
                    //
                }
                //
                //

                if (this.filter_km[0] > filter.km.min || this.filter_km[1] < filter.km.max) {
                    results = _.filter(results, result => result.km >= this.filter_km[0]);
                    results = _.filter(results, result => result.km <= this.filter_km[1]);
                    this.active_filters.push('km');
                    //
                }
                //
                //

                if (this.filter_preis[0] > filter.preis.min || this.filter_preis[1] < filter.preis.max) {
                    if (this.dealerPrices) {
                        results = _.filter(results, result => result.dpr >= this.filter_preis[0]);
                        results = _.filter(results, result => result.dpr <= this.filter_preis[1]);
                        this.active_filters.push('preis');
                    } else {
                        results = _.filter(results, result => result.pr >= this.filter_preis[0]);
                        results = _.filter(results, result => result.pr <= this.filter_preis[1]);
                        this.active_filters.push('preis');
                    }
                }

                let vehicle_filter_count_old = this.vehicle_filter_count;
                // set filtered count
                this.vehicle_filter_count = Object.keys(results).length;

                if(this.vehicle_filter_count !== vehicle_filter_count_old) {
                    // sth has changed, go to page 1
                    this.page = 0;
                }

                // set filtered state
                if(this.vehicle_filter_count !== (this.vehicle_count - this.clone_count)) {
                    // reset page
                    if (this.filtered === false) {
                        this.filtered = true;
                    }

                    this.max_pages = Math.ceil(this.vehicle_filter_count / this.perPage);
                }

                // memorize used filters
                this.active_filters = _.uniq(this.active_filters);

                // calc pages
                let offset = this.page * this.perPage;

                this.vehicles_displayed_from = offset + 1;
                this.vehicles_displayed_to = offset + this.perPage;

                // on last/only page?
                if(this.page + 1 === this.max_pages) {
                    if(this.vehicle_filter_count < (this.max_pages * this.perPage)) {
                        this.vehicles_displayed_to = this.vehicle_filter_count;
                    }
                }

                // sort results
                if (this.sortBy) {
                    if (this.sortBy === 'ca_desc') {
                        results = _.sortBy(results, 'ca').reverse();
                    }
                    if (this.sortBy === 'ez_asc') {
                        results = _.sortBy(results, 'ez');
                    }
                    if (this.sortBy === 'ez_desc') {
                        results = _.sortBy(results, 'ez').reverse();
                    }
                    if (this.sortBy === 'km_asc') {
                        results = _.sortBy(results, 'km');
                    }
                    if (this.sortBy === 'km_desc') {
                        results = _.sortBy(results, 'km').reverse();
                    }
                    if (this.sortBy === 'pr_asc') {
                        if (this.dealerPrices) {
                            results = _.sortBy(results, 'dpr');
                        } else {
                            results = _.sortBy(results, 'pr');
                        }
                    }
                    if (this.sortBy === 'pr_desc') {
                        if (this.dealerPrices) {
                            results = _.sortBy(results, 'dpr').reverse();
                        } else {
                            results = _.sortBy(results, 'pr').reverse();
                        }
                    }

                    //
                }

                // todo: make more compact because performance
                // do not paginate if leasing
                if(this.filter_leasing || this.mobile) {
                    results = Object.values(results);
                } else {
                    results = Object.values(results).slice(offset, offset + this.perPage);
                }

                // do paginate anyway if mobile, but only append results
                if(this.mobile) {
                    results = Object.values(results).slice(0, offset + this.perPage);
                }

                /*let searchParams = { // we don't do that here
                    'leasing': this.filter_leasing,
                    'type': this.filter_type,
                    'marke': this.filter_marke,
                    'modell': this.filter_modell,
                    'karosserie': this.filter_karosserie,
                    'motorisierung': this.filter_motorisierung,
                    'standort': this.filter_standort,
                    'extras': this.filter_extras,
                    'erstzulassung': this.filter_erstzulassung,
                    'km': this.filter_km,
                    'preis': this.filter_preis
                };

                // has interval been reset?
                if(this.trackSearchInterval === null) {
                    let that = this;
                    this.trackSearchInterval = setInterval(function() {
                        that.trackSearch(searchParams);
                    }, 5000);
                }*/

                return results;
            },

            vehicleFilterCount: function() {
                if(this.filter_leasing && this.lp_filter_count > 0) {
                    return this.vehicle_filter_count + this.lp_filter_count;
                }

                return this.vehicle_filter_count;
            },

            filteredLps: function() {

                if (this.lps == null) {
                    return [];
                }

                var results = this.lps;

                if (this.filter_marke.length > 0) {
                    results = _.filter(results, result => _.includes(this.filter_marke, result.fr_mk));
                } else if (this.filter_modell.length > 0) {
                    // cannot filter by model
                    return [];
                }

                this.lp_filter_count = Object.keys(results).length;

                return results;
            },

            filteredSpecialOffers: function() {

                if (this.special_offers == null) {
                    return [];
                }

                var results = this.special_offers;

                if (this.filter_marke.length > 0) {
                    results = _.filter(results, result => _.includes(this.filter_marke, result.fr_mk));
                }

                this.special_offer_filter_count = Object.keys(results).length;

                return results;
            },

            activeMainBrands: function() {
                return _.intersection(this.filter_marke, ['Ford', 'Volvo', 'Land Rover', 'Jaguar']);
            },

            leasingCount: function() {

                var results = this.vehicles;
                results = _.filter(results, result => result.cl === true); // clones
                results = _.filter(results, result => result.ls === 1);

                if(this.filter_marke.length > 0 && this.filter_modell.length > 0) {
                    results = _.filter(results, result => _.includes(this.filter_marke, result.fr_mk) || _.includes(this.filter_marke, result.mk) || _.includes(this.filter_modell, result.mlt));
                } else {
                    if (this.filter_marke.length > 0) {
                        results = _.filter(results, result => _.includes(this.filter_marke, result.fr_mk) || _.includes(this.filter_marke, result.mk));
                    }
                    if (this.filter_modell.length > 0) {
                        results = _.filter(results, result => _.includes(this.filter_modell, result.mlt));
                    }
                }

                return this.filteredLps.length + Object.keys(results).length;
            },

            paymentCount: function() {
                return this.lp_count + this.vehicle_count;
            },

            vehicleCount: function() {
                return this.vehicle_count;
            },

            maxPages: function() {
                return this.max_pages;
            },

            getCurrentPage: function() {
                return this.page + 1;
            },

            paginationPages: function() {

                let pagination = [];
                let page = this.page+1;
                let start = 1;
                let end = this.max_pages;

                if(this.max_pages > 5) {
                    end = 5;

                    if(page > 3 && page < this.max_pages - 2) {
                        start = page - 2;
                        end = start + 4;
                    }

                    if(page >= this.max_pages - 2) {
                        start = this.max_pages - 4;
                        end = this.max_pages;
                    }
                }

                var i;
                for (i = start; i <= end; ++i) {
                    pagination.push(i);
                }

                return pagination;
            },

            getPerPage: function() {
                return this.perPage;
            },

            getSortBy: function() {
                return this.sortBy;
            },

            getCountLoading: function() {
                return this.countLoading;
            },

            vehiclesDisplayedFrom: function() {
                return this.vehicles_displayed_from;
            },

            vehiclesDisplayedTo: function() {
                return this.vehicles_displayed_to;
            },

        },

        components : {
            Loading,
            VueMobileDetection,
            'vue-slider' : VueSlider,
        }
    });
}


// WEBPACK FOOTER //
// ./resources/js/component-vehicle-search.js